<template>
    <modal
        name="responsive-info-modal"
        :width="`100%`"
        :height="276"
        :min-width="480"
        :min-height="276"
        :pivotX="0.5"
        :pivotY="0.5"
        :delay="100"
        :clickToClose="false"
        v-bind:class="this.hidden ? 'hidden': ''"
        @before-open="beforeOpen"
    >
      <vue-scroll>
        <div class="FloatMenu md_overlay md_overlay_0 ">
        <div class="modal modal_0">
          <div class="md_content">
            <h6 class="--blue70">
              {{ $t('alert.info')}}
            </h6>
            <span
                class="md_close"
                @click="handleClose"
            >
              <img src="/images/union.svg" alt="">
            </span>
            <div class="message">
              {{$t('alert.responsive_message')}}
            </div>
            <div class="confirmBtn">
              <a
                  class="btn blue btn_basics pointer no-drag"
                  style="margin-right: 10px;"
                  @click="closePopup"
              >
                {{this.$t('modal.day')}}
              </a>
              <a
                  class="btn gray btn_basics pointer no-drag"
                  @click="handleClose"
              >
                {{this.$t('statistic.close')}}
              </a>
            </div>
          </div>
        </div>
      </div>
      </vue-scroll>
</modal>
</template>
<script>
import { setCookie, getCookie } from '@/static';

export default {
  name: 'responsiveInfoModal',
  components: {},
  props: [''],
  data() {
    return {
      hidden: false
    }
  },
  beforeMount() {
    setTimeout(() => {
      this.$modal.show('responsive-info-modal');
    })
  },
  methods: {
    modalClose: function () {
      this.$modal.hide('responsive-info-modal');
    },
    beforeOpen() {
      const cookieCheck = getCookie("popupYN");
      if (cookieCheck === "N") {
        this.hidden = true
      }
    },
    closePopup() {
      setCookie("popupYN", "N", 1);
      this.modalClose();
    },
    handleClose() {
      this.modalClose();
    }
  }
}
</script>
<style lang="scss">
@import "@/scss/default";
/* 1024이하 미지원 팝업 start */
.v--modal-overlay[data-modal="responsive-info-modal"] {
  display: none;
}

@media screen and (max-width: 1023px) {
  .v--modal-overlay[data-modal="responsive-info-modal"] {
    display: block;

    .md_overlay {
      background: none;
    }

    .message {
      height: 140px;
      color: #202020;
      font-size: 20px;
      font-weight: bold;
      line-height: 1.3;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .confirmBtn {
      display: flex;

      a {
        margin: 0 auto;
        max-width: 200px;
      }
    }

    .v--modal {
      box-shadow: none;
    }

    .md_content {
      height: 280px;
      width: 480px;
    }
  }
}
/* 미지원 팝업 end */
</style>